/**
 * Immutabley removes a key from an object
 */
export default function objectKeyRemove<T>(obj: T, key: keyof T): Omit<T, keyof T> {
  const { [key]: omitted, ...rest } = obj;
  return rest;
}
